//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import ReactAngularWidget, {
  NgWrapperDivProps,
} from '@react-bridge/react-angular-widget';
import 'app/components/common/queued-upload/queued-upload';

interface IOwnProps {
  uuid: string;
}

export class QueuedUpload extends ReactAngularWidget<
  IOwnProps & { ngWrapperDivProps?: NgWrapperDivProps }
> {
  public html(): string {
    return `
      <queued-upload uuid="uuid"></queued-upload>
    `;
  }
}
